import { render, staticRenderFns } from "./VCreateUserForm.vue?vue&type=template&id=728c1782"
import script from "./VCreateUserForm.vue?vue&type=script&lang=js"
export * from "./VCreateUserForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports